import { PATHS } from 'routes/constants';

/** Build environment */
export const BUILD_ENV = process.env.NODE_ENV;
// export const IS_DEVELOPMENT = BUILD_ENV === 'development';
// export const IS_TEST = BUILD_ENV === 'test';
// export const IS_PRODUCTION = BUILD_ENV === 'production';
export const APP_WEB_API_URL_PROD = 'https://mpm.easproject.com';
export const APP_WEB_API_URL_DEV = 'https://mpm-dev.easproject.com';
export const APP_WEB_API_PAY_URL_PROD = 'https://pay.easproject.com';
export const APP_WEB_API_PAY_URL_DEV = 'https://pay-dev.easproject.com';

export const IS_PRODUCTION = window.location.origin === APP_WEB_API_URL_PROD;
export const IS_DEVELOPMENT = !IS_PRODUCTION;

/** Permissions */
export const ALLOW_DEV_CONSOLE = process.env.REACT_APP_ALLOW_DEV_CONSOLE === 'true';
export const ALLOW_REDUX_DEVTOOLS_EXTENSION =
	process.env.REACT_APP_ALLOW_REDUX_DEVTOOLS_EXTENSION === 'true';
export const ALLOW_WINDOW_EXTENDS = process.env.REACT_APP_ALLOW_WINDOW_EXTENDS === 'true';

/** App */
export const APP_NAME = process.env.REACT_APP_NAME;
export const STORAGE_PREFIX = process.env.REACT_APP_STORAGE_PREFIX;

/** API */

export const WEB_API_URL = IS_PRODUCTION ? window.location.origin : APP_WEB_API_URL_DEV;

export const WEB_API_PAY_URL = IS_PRODUCTION ? APP_WEB_API_PAY_URL_PROD : APP_WEB_API_PAY_URL_DEV;

export const REDIRECT_URL = window.location.origin;

export const KEYCLOAK_URL_PROD = 'id.easproject.com';
export const KEYCLOAK_URL_DEV = 'id-dev.easproject.com';

export const HOST_KEYCLOAK =
	window.location.origin === APP_WEB_API_URL_PROD ? KEYCLOAK_URL_PROD : KEYCLOAK_URL_DEV;

export const ID_URL = `https://${HOST_KEYCLOAK}/auth/realms/dashboard/protocol/openid-connect/auth?response_type=code&client_id=merchmodule-ui&redirect_uri=${
	REDIRECT_URL
		? `${REDIRECT_URL}${PATHS.AUTH_CODE_PAGE}`
		: `http://localhost:3000${PATHS.AUTH_CODE_PAGE}`
}`;

export const PAGE_SIZE = 20;

export const VAT_CORRECTION_CREATION_DATE = '2025-04-03';

export enum EYesNo {
	YES = 'yes',
	NO = 'no',
}
